import { Injectable } from '@angular/core';
import { AbstractGraphqlRequest, GraphqlRequestType } from '@ckmk/angular';
import { TypedDocumentNode } from '@apollo/client';
import { ServiceCategoryModel } from '@app/src/app/modules/service/classes/category/model/service.category.model';
import { gql } from 'apollo-angular';

@Injectable({
  providedIn: 'root',
})
export class ServiceCategoriesPublicRequestQuery extends AbstractGraphqlRequest<
  ServiceCategoryModel[]
> {
  protected override type: GraphqlRequestType = 'query';

  protected override getQuery(): TypedDocumentNode<any, any> {
    return gql`
      query findPublicAllServiceCategories(
        $payload: ServiceCategoryRequestPayloadInput
      ) {
        findPublicAllServiceCategories(payload: $payload) {
          cover {
            name
            extension
            directory
            directories
            frontUrls
            mimetype
          }
          slug
          title
          description
          shortDescription
          data {
            leftColor
            rightColor
          }
        }
      }
    `;
  }

  protected override onParseResult(data: any, payload?: any) {
    let items = data.findPublicAllServiceCategories;

    if (Array.isArray(items)) {
      return items.map((item: any) => new ServiceCategoryModel(item));
    }

    return [];
  }
}
